import Router from "routers/login.router";
import i18n from "l10n";
import "parallax";
import {Backbone} from 'backboneAdapter';

$(document).ready(() => {
    $('[data-i18n]').i18n();
    $('.i18n-href[href]').each(function () {
        const self = $(this);
        let href = self.attr('href');
        while (href.indexOf('{}') > -1)
            href = href.replace('{}', i18n.language);
        self.attr('href', href);
    });
    const $html = $('html');
    $html.attr('lang', i18n.language);
    $html.attr('dir', i18n.getDir());
    const $body = $('body');
    $body.addClass(i18n.getDir());

    new Router();
    Backbone.history.start();

    function addElement(selector, initial, multiplier) {
        return {
            'selector': selector,
            'properties': {
                'x': {
                    'background-position-x': {
                        'initial': initial,
                        'multiplier': multiplier,
                        'invert': true
                    }
                }
            }
        };
    }

    function addElementBg(selector, multiplier) {
        return addElement(selector, 0, multiplier);
    }

    const elements = [
        addElementBg('.bg-1', 0.02),
        addElementBg('.bg-2', 0.06),
        addElementBg('.bg-3', 0.2),
        addElementBg('.bg-4', 0.01),
        addElementBg('.bg-5', 0.03),
        addElementBg('.bg-6', 0.06),
        addElement('.alien-1', -40, 0.04),
        addElement('.alien-2', -80, 0.08),
        addElement('.alien-3', -100, 0.1)
    ];

    $body.parallax({
        'elements': elements
    });
});